export default {
  V_ICON_CALENDAR: 'mdi-calendar',
  V_ICON_LIST_EVENTS: 'mdi-clipboard-list-outline',
};
